import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import DestinationsPage from "./pages/DestinationsPage";
import PackagesPage from "./pages/PackagesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import CancelPage from "./pages/CancelPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import FAQPage from "./pages/FAQPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import CareersPage from "./pages/CareersPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminPricingPage from "./pages/AdminPricingPage";
import AgentLoginPage from "./pages/AgentLoginPage";
import AgentDashboardPage from "./pages/AgentDashboardPage";
import WalletPage from "./pages/WalletPage";
import { Toaster } from "./components/ui/toaster";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/destinations" element={<DestinationsPage />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/cancel" element={<CancelPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/pricing" element={<AdminPricingPage />} />
          <Route path="/agent/login" element={<AgentLoginPage />} />
          <Route path="/agent" element={<AgentDashboardPage />} />
          <Route path="/wallet" element={<WalletPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
